export default __webpack_public_path__ + "static/media/sidebar-1.674c6309.jpg";